// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__y49bA","title":"privacy_title__p-fkJ","close":"privacy_close__2Lmon","body":"privacy_body__buLR6"};